export default __webpack_public_path__ + "static/studycafe-office6-845b29481f74c37c5ac8be124e3f4768.jpg";